import { boot } from 'quasar/wrappers'
import SocialSharing from 'vue-social-sharing'

export default boot(({ app }) => {
	app.use(SocialSharing)
})
